export default __webpack_public_path__ + "static/media/selenium.4a0e796d.svg";